import { render, staticRenderFns } from "./product-summary-card.vue?vue&type=template&id=3ac2c3d8"
import script from "./product-summary-card.vue?vue&type=script&lang=ts"
export * from "./product-summary-card.vue?vue&type=script&lang=ts"
import style0 from "./product-summary-card.vue?vue&type=style&index=0&id=3ac2c3d8&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports